import * as types from '../mutation-types'

const state = {
    aside_collapsed: false,
    is_multi_station: false
}

const mutations = {
    // 接受一个状态 true/false
    [types.ASIDE_COLLAPSE] (state, status) {
        state.aside_collapsed = status;
    }
}

const actions = {
    
}

const getters = {
    aside_collapsed: state => state.aside_collapsed,
}

export default {
    state,
    mutations,
    actions,
    getters
}